export const targetListColumns = [
  {
    title: "图片",
    width: 90,
    align: "center",
    // dataIndex: "unit"
    scopedSlots: { customRender: "goodsImg" }
  },
  {
    title: "货品名",
    width: 420,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "goodsName"
  },
  {
    title: "货品编号",
    width: 140,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "goodsNo"
  },
  {
    title: "类别",
    width: 140,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "categoryName"
  },
  {
    title: "规格型号",
    width: 280,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "goodsSpec"
  },
  {
    title: "品牌",
    width: 160,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "goodsBrand"
  },
  {
    title: "单位",
    width: 90,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "goodsUnit"
  }
]
